
<template>
  <div class="attachment-div">
    <!-- {{attachment.id}} -->
    <div v-viewer="viewerOptions">
      <img
        class="attachment-img-div"
        :src="url"
        :key="attachmentId"
        :data-href="attachmentName"
        alt=" "
      />
    </div>
    <div class="mt-2 attachment-discard-div">
      <a v-if="discardVisible" href="#" @click.prevent="discard">
        <label class="link">
          {{ $t("geral.discard") }}
        </label>
      </a>
    </div>
    <div class="textAttachment" v-if="attachmentNumber != null">
      Anexo {{ attachmentNumber }}
    </div>

    <!-- {{attachments}} -->
    <!-- {{attachmentSrc}} -->
    <!-- <div>attachmentSrc: {{attachmentSrc}}</div> -->
    <!-- <div>attachmentId: {{attachmentId}}</div> -->
    <!-- <div>attachmentName: {{attachmentName}}</div> -->
  </div>
</template>
  
<script>
import axios from "axios";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";

Vue.use(Viewer);

export default {
  name: "AuthedImage",
  props: {
    attachmentSrc: String,
    attachmentId: String,
    attachmentName: String,
    attachmentNumber: Number,
    discardVisible: Boolean,
    token: {
      description: "Token de acesso",
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      url: "",
      viewerOptions: {
        movable: true,
        rotatable: false,
        scalable: false,
        navbar: false,
        title: false,
        fullscreen: false,
        rotatable: true,
        zoomable: true,
        toolbar: true,
      },
    };
  },
  created() {
    this.getImage();
  },
  computed: {},
  methods: {
    discard() {
      this.$emit("discard", this.attachmentId);
    },
    async getImage() {
      axios
        .request({
          url: `${this.attachmentSrc}`,
          method: "GET",
          responseType: "arraybuffer",
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          const base64 = btoa(
            new Uint8Array(response.data).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
          this.url = `data:image/png;charset=utf-8;base64,${base64}`;
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            console.log(error.response.data.errors);
          }
        });
    },
  },
};
</script>
  
<style scoped>
.attachment-div {
  border: 1px;
  border-color: #2b3553;
  border-radius: 0.4285rem;
  border-style: solid;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  margin-top: 10px;
  margin-bottom: 15px;
  text-align: center;
}
.attachment-discard-div {
  text-align: center;
}
.attachment-img-div {
  align-items: center !important;
  /* display: flex; */
  max-width: 100%;
  max-height: 100%;
  height: 240px;
}
.textAttachment {
  text-align: center !important;
}
.link {
  cursor: pointer;
}
.link:hover {
  color: white !important;
}
</style>